import { Component, Inject } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { PassSiiService } from '../../service/pass-sii.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { AuthService } from 'src/app/pages/authentication/service/auth.service';
import { delay, finalize } from 'rxjs';

@Component({
  selector: 'app-change-siipass',
  templateUrl: './change-siipass.component.html',
  styleUrls: ['./change-siipass.component.scss'],
})
export class ChangeSIIPassComponent {
  form!: FormGroup;
  isMinuteCreate: boolean = false;
  public validateRutSii: boolean = false;
  booleanFlag: boolean = false;
  booleanText: boolean = false;
  showSection: boolean;

  constructor(
    private fb: FormBuilder,
    private service: PassSiiService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ChangeSIIPassComponent>,
    private auth: AuthService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      passSII: ['', Validators.required],
    });
  }

  submit() {
    const SIIPassword = this.form.value.passSII;
    const CompanyRut = this.data.rut;
    console.log(this.data);

    Swal.fire({
      title: 'Actualizando Contraseña',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading();
        this.service.changeSIIPass(CompanyRut, SIIPassword).subscribe({
          next: (e) => {
            console.log(e);
            Swal.fire({
              title: e.message,
            }).then((result) => {
              if (result.isConfirmed) {
                this.isMinuteCreate = true;
                this.dialogRef.close(this.isMinuteCreate);
              }
            });
          },
          error: (error) => {
            console.log(error);
            Swal.fire({
              title: error.error.message,
              text: 'No fue posible añadir al usuario',
              icon: 'error',
              showConfirmButton: true,
              confirmButtonText: 'Cerrar',
            });
          },
        });
      },
    });
  }

  cerrarDialogo() {
    this.dialogRef.close();
  }


  validateSii() {
    this.booleanFlag = true;
    this.booleanText = true;
    this.showSection = false;
    const SIIPassword = 'validar';
    const CompanyRut = this.data.rut;
  
    this.service.changeSIIPass(CompanyRut, SIIPassword).subscribe({
      next: (res) => {
        console.log(res);
        this.booleanText = false;
        this.booleanFlag = false;
       
          
        
        if (res.siiCredentialValidationState == 2) {
          this.showSection = false;
          this.isMinuteCreate = true;
          this.dialogRef.close(this.isMinuteCreate);
          return (this.data.isSiiConnected = true);
        }
        this.showSection = true;
        return (this.data.isSiiConnected = false);
      },
      error: (res) => {
        console.log(res);
      },
      complete: () => {},
    });
  }
}
